/**
 * Parse a "YYYY-MM-DD" match date string into a Date at local midnight.
 * Without this, `new Date("2026-04-01")` is parsed as UTC and can render
 * a day earlier in negative-UTC timezones like Antigua (UTC-4).
 */
export const parseMatchDate = (dateStr) => {
  if (!dateStr) return null;
  // If it already has a time component, trust it as-is
  if (typeof dateStr === "string" && dateStr.length === 10 && /^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const [y, m, d] = dateStr.split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  return new Date(dateStr);
};

/**
 * Format a match date string ("YYYY-MM-DD") using local-calendar semantics.
 * `opts` follows Intl.DateTimeFormat options.
 */
export const formatMatchDate = (dateStr, opts, locale = "en-US") => {
  const d = parseMatchDate(dateStr);
  if (!d || isNaN(d.getTime())) return "";
  return d.toLocaleDateString(locale, opts);
};
